<script setup lang="ts">
import { useToggleStore } from '@/store/toggle/toggle'

import HeaderCitySelect from '@/components/Header/HeaderCitySelect.vue'
import HeaderDeliveryTime from '@/components/Header/HeaderDeliveryTime.vue'
import HeaderDeliveryWidget from '@/components/Header/HeaderDeliveryWidget.vue'
import HeaderLogo from '@/components/Header/HeaderLogo.vue'
import HeaderPhones from '@/components/Header/HeaderPhones.vue'
import HeaderWorkingHours from '@/components/Header/HeaderWorkingHours.vue'

type Props = {
  cityName: string
  phones: string[]
  isActive: boolean
}

defineProps<Props>()

const { newAddressFlowEnabled } = useToggleStore()
</script>

<template>
  <div class="header-info">
    <header-logo class="header-info__logo" is-desktop />

    <div class="header-info__wrapper">
      <div class="header-info__city">
        <header-city-select :city-name="cityName" />

        <header-working-hours />
      </div>

      <header-delivery-widget v-if="newAddressFlowEnabled" />

      <header-delivery-time v-else />

      <header-phones v-if="isActive" :phones="phones" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header-info {
  display: flex;
  align-items: center;

  &__logo {
    margin-right: 32px;

    @include media('>=desktop') {
      margin-right: 64px;
    }
  }

  &__wrapper {
    display: flex;
    gap: 24px;
    align-items: center;
  }

  &__city {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
}
</style>
